export interface IAppConfig {
  addUrl: string;
  getUrl: string;
  updateUrl: string;
  removeUrl: string;
}
